import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopSkills = async (urlDataAPI: any) => {
    const { exportType, hubIds, sectorIds, occupationCategoryIds, isceD4Codes, locations, isEntryLevel, type } = urlDataAPI;

    const { path, method } = endpoints.skill.exportTopSkills;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, ISICCodes: sectorIds, ISCO2Codes: occupationCategoryIds, isceD4Codes, locations, isEntryLevel, type },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
